module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('label', {
    staticClass: "typo__label"
  }, [_vm._v("Cols:")]), _c('multiselect', {
    attrs: {
      "options": _vm.fields,
      "multiple": true,
      "label": "field",
      "track-by": "field"
    },
    model: {
      value: (_vm.cols),
      callback: function($$v) {
        _vm.cols = $$v
      },
      expression: "cols"
    }
  }), _c('label', {
    staticClass: "typo__label"
  }, [_vm._v("Rows:")]), _c('multiselect', {
    attrs: {
      "options": _vm.fields,
      "multiple": true,
      "label": "field",
      "track-by": "field"
    },
    model: {
      value: (_vm.rows),
      callback: function($$v) {
        _vm.rows = $$v
      },
      expression: "rows"
    }
  }), _c('br'), _c('crosstab', {
    attrs: {
      "data": _vm.data,
      "rows": _vm.rows,
      "cols": _vm.cols,
      "cellWidth": 60,
      "fontSize": 10,
      "height": "300"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1d64a142"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./docs/partials/examples/UIControls.vue
// module id = 56
// module chunks = 0